<template lang="pug">
div
  div(v-if="!list || !list.length")
    span 不限
    span.btn(v-if="!onlyshow" @click="showUserProfile = true") ，点击新增
  .userpfs(v-else)
    template(v-for="(item, i) in list")
      el-popover(placement="top" trigger="hover" popper-class="userpfs_pop")
        span.btn(slot="reference" style="cursor: default;display: inline-block;") {{ userPfNames[i] }}
        span {{userPfNames[i]}}：{{ item.list.map(el => el.name).join('+') }}
      i(v-if="i < list.length - 1") 或
    .fr.btn(v-if="!onlyshow" @click="changeUPs") 修改
  el-dialog(
    :title=" (list && list.length ? '修改' : '新增') + '用户画像'"
    width="790px" height="500px" :append-to-body="true" :close-on-click-modal="false"
    :visible.sync="showUserProfile" custom-class="profile_pop user_profile")
    .ctn
      .top 标签选择
        span 精准每个画像的标签，标签过多会影响数据精度
      div
        UserProfileObjs(v-model="profileData" ref="Upf")
    span(slot="footer")
      .fix-btn.red(@click="changeProfile") 确定
      .fix-btn(@click="closeProfile") 取消
    
</template>

<script>
import UserProfileObjs from '@/views/PutOrder/components/OrderForm/UserProfileObjs'
import { jointUserPf } from '@/utils/functions'
export default {
  name: 'UserProfileChange',
  components: { UserProfileObjs },
  props: {
    value: Array, codes: [Array, String, undefined], onlyshow: [Boolean, undefined]
  },
  data () {
    return {
      showUserProfile: false,
      profileData: [],
      profileDataConfirm: [],
      userPfNames: ['画像A', '画像B', '画像C', '画像D', '画像E']
    }
  },
  computed: {
    list: {
      get () { return this.value && this.value.filter(el => el.list.length) || [] },
      set (v) { this.$emit('input', v) }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (v) { // 取消展开之后 选中确定的数据状态
        if (!v) return
        let vStr = JSON.stringify(v)
        this.profileData = JSON.parse(vStr)
        this.profileDataConfirm = JSON.parse(vStr)
      }
    }
  },
  methods: {
    async judgeUpdateUp () {
      let codes = Array.isArray(this.codes) ? this.codes.join(',') : this.codes
      let res = await this.fetch('/dsp/web/order/v2/orderTargetInfo/state', { orderCodes: codes }, 'get')
      if (res && res.code == this.successCode) return { next: true }
      return
    },
    async changeUpFn (data) { // 修改用户画像接口请求
      let opt = {
        orderCodes: Array.isArray(this.codes) ? this.codes : this.codes.split(','),
        labelCodes: data.filter(el => el.list && el.list.length).map(el => el.list.map(el => el.code))
      }
      let res = await this.fetch('/dsp/web/order/v2/orderTargetInfo', opt, 'post')
      if (res && res.code == this.successCode) return { next: true }
      return
    },
    async changeUPs () {
      let load = this.$loading ? this.$loading() : null
      let res = await this.judgeUpdateUp()
      if (load) load.close()
      if (res && res.next) this.showUserProfile = true
    },
    closeProfile () {
      this.$refs.Upf.closePopovers() // 关闭画像选择列表组件弹窗
      this.showUserProfile = false
      this.profileData = JSON.parse(JSON.stringify(this.profileDataConfirm)) // 复原数据 深拷贝保存确认数据 以免数据联动影响
    },
    saveUiChange () {
      let names = [ '画像A', '画像B', '画像C', '画像D', '画像E' ]
      // 选择可能会中间有空画像，过滤重排下保存
      this.profileDataConfirm = this.profileData.filter(el => el.list.length).map((element, i) => ({ ...element, name: names[i], show: false }))
      this.closeProfile() // closeProfile 时 profileData 又重新深拷贝了一下
      this.$emit('input', this.profileDataConfirm)
    },
    hasSame (list) {
      let all = list.map(el => el.list.map(el => el.code).sort().join('')).filter(el => el)
      let set = [...new Set(all)]
      return all.length > set.length
    },
    async changeProfile () {
      if (this.hasSame(this.profileData)) return this.messageTip('画像数据不能重复', 2)
      let load = this.$loading ? this.$loading() : null
      let res = await this.changeUpFn(this.profileData)
      if (load) load.close()
      if (res && res.next) this.saveUiChange()
    },
  }
}
</script>

<style lang="scss" scoped>
.userpfs {
  i {
    margin: 0 5px;
  }
}
.btn {
  color: #421EEF;
  cursor: pointer;
}
.ctn {
  border: 1px solid #D4D4D4;
  height: 100%;
  overflow: auto;
}
.top {
  background: #F5F5F5;
  font-weight: 550;
  text-align: left;
  padding-left: 20px;
  line-height: 40px;
  span {
    color: #999;
    font-size: 12px;
    font-weight: normal;
    margin-left: 10px;
  }
}
</style>

<style lang="scss">
.userpfs_pop {
  border: 1px solid #282729;
  text-align: center;
  .popper__arrow {
    border-top-color: #282729!important;
  }
}
  
  // .userpfs
  //   line-height: 1
  //   margin-bottom: 10px
  //   color: #282729
  
.profile_pop.user_profile {
  text-align: center;
  top: 50%;
  margin-top: -260px !important;
  .el-dialog__body {
    padding: 20px;
    height: 420px;
    border-top: 1px solid #E9E9E9;
    border-bottom: 1px solid #E9E9E9;
  }
  .el-dialog__footer {
    padding: 0;
    text-align: center;
  }
}
</style>